(function () {
    const popUpFunction = function () {
        const popUpLinks = document.querySelectorAll('.data-popup[data-popup-content]');

        if (popUpLinks) {
            const info = document.querySelector('.info-popup--info');
            const content = document.querySelector('.info-popup--content-html');
            let showInfo = true;

            popUpLinks.forEach(function (popUp) {
                popUp.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (showInfo) {
                        content.innerHTML = popUp.getAttribute('data-popup-content');
                        info.classList.add('visible');
                        showInfo = false;
                    } else {
                        info.classList.remove('visible');
                        showInfo = true;
                    }
                    return false;
                });
            });
            info.addEventListener('click', function (e) {
                if (!e.target.href) {
                    e.preventDefault();
                }
                info.classList.remove('visible');
                showInfo = true;
            });
        }
    };

    document.addEventListener('readystatechange', popUpFunction);
})();
